import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class Uploads3Service {

  private lambdaUrl = environment.lambdaUrl;

  constructor(private http: HttpClient) {}

  private getHeaders(): HttpHeaders {
    const token = localStorage.getItem('token') ?? localStorage.getItem('token1') ?? '';
    return new HttpHeaders({ 'Authorization': token, 'Content-Type': 'application/json' });
  }

  private async fetchSignedUrl(url: string, init: RequestInit, errorMessage: string): Promise<void> {
    const response = await fetch(url, init);

    if (!response.ok) {
      throw new Error(`${errorMessage}: ${response.status} ${response.statusText}`);
    }
  }

  private validateLambdaUrl(): void {
    if (!this.lambdaUrl) {
      throw new Error('No se tiene configurada la URL de Lambda para documentos.');
    }
  }

  async uploadToS3(folder: string, file: File, directorio: string | number): Promise<string> {
    this.validateLambdaUrl();

    const fileType = file.type || 'application/pdf';

    const { uploadUrl, fileUrl } = await lastValueFrom(
      this.http.post<{ uploadUrl: string; fileUrl: string }>(
        this.lambdaUrl,
        {
          action: 'upload',
          folder,
          directorio: String(directorio),
          fileName: file.name,
          fileType,
        },
        { headers: this.getHeaders() }
      )
    );

    await this.fetchSignedUrl(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': fileType },
    }, 'Error al subir archivo a S3');

    return fileUrl;
  }

  async deleteFileS3(foldertype: string, folder: string | number, namePdf: string): Promise<string> {
    this.validateLambdaUrl();

    const { deleteUrl } = await lastValueFrom(
      this.http.post<{ deleteUrl: string }>(
        this.lambdaUrl,
        {
          action: 'delete',
          folder: foldertype,
          directorio: String(folder),
          fileName: namePdf,
        },
        { headers: this.getHeaders() }
      )
    );

    await this.fetchSignedUrl(deleteUrl, { method: 'DELETE' }, 'Error al eliminar archivo de S3');

    return 'Archivo eliminado con éxito';
  }

  async getViewUrl(folder: string, directorio: string | number, fileName: string): Promise<string> {
    this.validateLambdaUrl();

    const { viewUrl } = await lastValueFrom(
      this.http.post<{ viewUrl: string }>(
        this.lambdaUrl,
        {
          action: 'view',
          folder,
          directorio: String(directorio),
          fileName,
        },
        { headers: this.getHeaders() }
      )
    );

    return viewUrl;
  }
}
